
<template>
	<div>
		<div id="ctl00_mainContent_cppMiddle_lt_mainZone_Carousel_SlideTwo" class="item banner banner-image">
			<div class="banner-image_container">
				<div class="banner-image_container"><img src="/dist/img/quote-tool-banner-background.jpg" class="img-responsive banner-image"></div>
			</div>

			<div class="container banner-image_content">
				<div class="content content-box left-content">
					<!-- <h1>How we add value to your business</h1> -->
					<p class="" v-html="this.labels.introSubHeading"></p>
					<button class="btn--chevron" @click="startQuoteTool">{{ labels.introStartButton }}</button>
					<!-- <a class="btn btn-primary" href="/pure">Find out more</a> -->
				</div>
				<div class="middle-content-container"></div>
			</div>
		</div>

		<section class="section-features">
			<div class="container">
				<div class="row">
					<div class="features col-sm-6">
						<h2 class="features__title">{{ labels.introWhyS4BHeading }}</h2>
						<div v-html="labels.introWhyS4BText"></div>
					</div>
					<div class="features col-sm-6">
						<h2 class="features__title">{{ labels.introWhatInfoNeededHeading }}</h2>
						<div>
							<ul class='tick-list'>
								<li>Your main business details such as contact information and billing address</li>
								<li>The
									<div class="quote-popup quote-popup--inline">
										<span class="quote-popup__toggle">Supply Point IDs</span>
										<div class="quote-popup__modal">
											<table>
												<tbody>
													<tr>
														<td>
															<strong>More about your SPID</strong>
															<ul>
																<li>Your SPID number may appear on the first or second page of your bill and comprises 12 digits and one letter</li>
																<li>It will normally, but not always start with 301 or 302</li>
																<li>You might have separate SPIDs for your water supply and wastewater. We only need one of these as they are interlinked</li>
															</ul>
														</td>
														<td><img class="quote-popup__image" src="/dist/img/spid-placeholder.jpg" /></td>
													</tr>
												</tbody>
											</table>
										</div>
									</div>
									(SPIDs) or property number(s) of all site(s) within your business. You can find these in the top right-hand corner of your bill
								</li>
								<li>If you are an existing customer, the customer number(s) of all sites within your business. You'll also find these on your bill</li>
								<li>An estimate of annual <strong>water usage</strong> at each site(s) - we can estimate this using SPIDs</li>
								<li>Bank details - you'll need your account number & sort code if paying by Direct Debit - but you can also pay by BACS.</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</section>

		<div class="container">
			<!-- TrustBox widget - Carousel -->
			<div ref="trustbox" class="trustpilot-widget" data-businessunit-id="602cdbce6d4d040001b3b787" data-locale="en-GB"
				 data-review-languages="en" data-stars="1,2,3,4,5" data-style-height="170px" data-style-width="100%"
				 data-template-id="53aa8912dec7e10d38f59f36" data-theme="light">
				<a href="https://uk.trustpilot.com/review/source4b.co.uk" rel="noopener" target="_blank">Trustpilot</a>
			</div>
			<!-- End TrustBox widget -->
		</div>

		<section class="notice">
			<div class="container">
				<h2 class="notice__title text-center ">{{ labels.introBeforeStartHeading }}</h2>
				<div v-html="labels.introBeforeStartText"></div>
			</div>
		</section>

		<div class="container">
			<div v-html="labels.introReminderBox" class="alert-box--green"></div>

			<button class="btn--chevron" @click="startQuoteTool">{{ labels.introStartButton }}</button>

		</div>

	</div>
</template>

<script>
	import { mapActions, mapState } from 'vuex';
	export default {
		methods: {
			...mapActions('stepProgress', [
				'startQuoteTool'
			])
		},

		computed: {
			...mapState('microcopy', [
				'labels',
			])
		},

		mounted() {
			const trustbox = this.$refs.trustbox;
			if (window.Trustpilot) {
				window.Trustpilot.loadFromElement(trustbox);
			}
		},
	}
</script>
<style></style>
